<template>
  <div id="app" class="mb-5">
    <div id="header" class="container-fluid">
      <!-- TODO: Shrink image size -->
      <img src="./assets/logo.png" class="img-fluid" alt="Responsive image" style="height: 200px">
      <hr style="width: 100%; color: black; height: 1px; background-color:black;"/>
    </div>
    <div id="nav-bar" class="container mb-3">
      <ul class="nav nav-fill">
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'home'}">
            Home
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'products', params: {product: 'overview' }}">
            Products
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'construction'}">
            Construction
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'about'}">
            About
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'contact'}">
            Contact
          </router-link>
        </li>
      </ul>
    </div>
    <div id="content" class="container">
      <div class="row">
        <div class="col-auto">
          <router-view name="leftNav"></router-view>
        </div>
        <div class="col">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        overview: {
          soilRetention: '',
          text: 'The industry-leading tradition of Euro Precast Concrete originated more than 50 years ago in Denmark at our parent company, Give Elementer, a leading supplier of precast concrete components for commercial, industrial, agricultural and residential applications.'
        }
      }
    }
  }
</script>

<style>
  #nav-bar {
    background-color: #7b7979;
  }

  .nav-link {
    color: black;
  }

  #app h2 {
    color: #ed1c24;
  }

  #header {
    text-align: center;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
